import {priority} from '@priority-software/priority-proto-api/lib';
import {ICondition} from './Condition';

export interface IFilter {
    Condition: ICondition[];
    Operator: priority.netitems.shared.LogicalOperator | null;
}

export class Filter implements IFilter {
    public Condition: ICondition[];
    public Operator: priority.netitems.shared.LogicalOperator;

    constructor(properties?: priority.netitems.form.IFilter) {
        this.Condition = properties?.Condition || [];
        this.Operator = properties?.Operator;
    }
}
